// routes/_embedded.embedded.chat-editing._index.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_embedded.embedded.chat-editing._index')

export const handle = { name: 'embedded-chat-editing' }

export default dynamic(getClientModule, { ssr: false })
